//TODO: Move constants from server folder to here so that we can use the same constants across both server and client directory

export const CONSUMER = 'consumer'
export const MERCHANT = 'merchant'
// min characters required for search
export const MIN_LENGTH_SEARCH_CHAR = 2
// max characters required for search
export const MAX_LENGTH_SEARCH_CHAR = 100
export const PERSONAL = 'personal'
export const BUSINESS = 'business'
export const TECHNICAL = 'technical'
export const JP = 'JP'
export const PAYPAL_OBJECTS_BASE_URL = 'https://www.paypalobjects.com'
export const YT_IFRAME_SCRIPT_URL = 'https://www.youtube.com/iframe_api'
export const pageNames = {
  HOME: 'home',
  ARTICLE: 'article',
  TOPIC: 'topic',
  HELP_GUIDES: 'helpGuides',
  SEARCH: 'search',
  PERSONAL: 'personal',
  BUSINESS: 'business',
  TECHNICAL: 'technical',
  COMPLAINTS: 'complaints',
}
export const signInUri = '/signin/?returnUri='
export const AUTHFLOW_PASSWORD_RECOVERY_URL = '/authflow/password-recovery'
export const FAQ = 'FAQ'
export const INTENT_TYPE_GENERIC = 'GENERIC'
export const chatBotMessageUsRefIdsMapping = {
  GENPOOL_CONTACT_US: 'GENPOOL|contactUsPage',
  GENERIC: 'GENPOOL',
  FINAL_INTENT: 'finalIntent',
  GENPOOL_ARTICLE_PAGE: 'GENPOOL|articlePage',
  GENPOOL_HOME_PAGE: 'GENPOOL|homePage',
}
export const BNA = 'BNA'
export const OMNI = 'OMNI'
export const MTS = 'MTS'
export const FAQ_CHANNELS = [FAQ, MTS]
export const NON_FAQ_CHANNELS = [OMNI, BNA]
export const recommendedSolutionsTitleLimits = {
  desktop: 36,
  tablet: 36,
  mobile: 21,
}
export const deviceTypes = {
  desktop: 'desktop',
  tablet: 'tablet',
  mobile: 'mobile',
}
export const COMPLAINT_REASON_CODE = 'complaintReasonCode'
export const COMPLAINT_REASON_CODES = {
  FEEDCOMPLAIN011: 'FEEDCOMPLAIN011',
  FEEDCOMPLAIN012: 'FEEDCOMPLAIN012',
  FEEDCOMPLAIN013: 'FEEDCOMPLAIN013',
  FEEDCOMPLAIN014: 'FEEDCOMPLAIN014',
  FEEDCOMPLAIN019: 'FEEDCOMPLAIN019',
}
export const POSITIONS = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
}

export const YES = 'yes'
export const NO = 'no'

export const SEARCH_ERROR_TYPES = {
  MIN_SEARCH_QUERYVALIDATION_ERROR: 'Min search query validation error',
  MAX_SEARCH_QUERYVALIDATION_ERROR: 'Max search query validation error',
  NO_SEARCH_RESULTS_ERROR: 'No search results for the search query',
  SEARCH_RESULTS_SERVICE_ERROR: 'API/Service error',
}

export const CHAT_ENTRY_POINTS = {
  // Article page
  ARTICLE_PAGE: 'help_center%article%{articleId}',
  // Contact us page home - default contact option
  CONTACT_PAGE_HOME_MESSAGE_US: 'help_center%contact%home%message_us',
  // Contact us final intent clicking on IDI option
  CONTACT_PAGE_INTENT_MESSAGE_US:
    'help_center%contact%intent%message_us%{intentId}',
  // Contact Us home - click on Green/small blue Pill
  CONTACT_PAGE_MESSAGE_US_PROMPT: 'help_center%contact%message_us_prompt',
  // Contact Us call us page - click on message us
  CONTACT_PAGE_CALLUS_MESSAGE_US: 'help_center%call_us%message_us',
  // contact privacy page message us
  CONTACT_PRIVACY_FAQ_MESSAGE_US: 'help_center%contact%privacy_faq',
  // Home page - need to pass exp page name
  HOME_PAGE_EXPERIENCE_MESSAGE_US: 'help_center%message_us%{pageName}',
  // Complaints page messageUs/Paypal assistant
  COMPLAINTS_PAGE_MESSAGE_US: 'help_center%complaints%message_us',
}
export const INVALID_CONTENT_REQUEST = 'INVALID_CONTENT_REQUEST'
export const SEARCH_ITEMS_PER_PAGE = 10
export const CHANNELS = {
  FAQ: 'faq',
  MTS: 'mts',
  BRC: 'brc',
  DEVELOPER: 'developer',
  PRODUCT: 'product',
  COMMUNITY: 'community',
}

export const TECH_SUPPORT_FILTER = {
  label: 'app.search.filter.docType.options.mts',
  channel: CHANNELS.MTS,
}

export const SEARCH_FILTERS = [
  {
    label: 'app.search.filter.docType.options.faq',
    channel: CHANNELS.FAQ,
    default: true,
  },
  // TECH_SUPPORT_FILTER,
  // commented since support is not there in ECM search
  // {
  //   label:'app.search.filter.docType.options.brc',
  //   channel: CHANNELS.BRC
  // },
  // {
  //   label:'app.search.filter.docType.options.developer',
  //   channel: CHANNELS.DEVELOPER
  // },
  // {
  //   label:'app.search.filter.docType.options.mpp',
  //   channel: CHANNELS.PRODUCT
  // },
  // {
  //   label: 'app.search.filter.docType.options.community',
  //   channel: CHANNELS.COMMUNITY,
  // },
]

export const DEFAULT_FILTER = SEARCH_FILTERS.find((filter) => filter.default)
